import {datasourcestore, DefaultEntity, EntityID, RestDataSource} from "@intermesh/goui";
import {ServerApi} from "../util/ServerApi.js";
import {User} from "../services/CurrentUser.js";

export interface MessageEntity extends DefaultEntity {
	id: EntityID,
	title: string,
	description: string,
	showAt: string,
	hideAt: string,
	showPopup: boolean,
	showOnce: boolean,
	showFrontEnd: boolean,
	createdBy: EntityID,
	createdAt: string,
	deleted: boolean
}

export interface MessageUserEntity extends DefaultEntity {
	id: EntityID,
	userId: EntityID,
	user: User,
	messageId: EntityID,
	message: MessageEntity,
	seen: boolean,
	dismissed: boolean
}

const MUparams = {
	returnProperties: "id,seen,dismissed,message[title,description,showPopup,showOnce,showFrontEnd,deleted]",
	orderColumn: "m.createdAt",
	orderDirection: "DESC",
	q: [[
		"andWhere", {
			"m.showFrontEnd": true
		}], [
		"andWhere", {
			'm.deleted': false
		}
	]]
}

export const messageUserDS = new RestDataSource<MessageUserEntity>(ServerApi.url("messaging/messageuser", MUparams, true), "messageUser");

export const messageUserStore = datasourcestore({
	dataSource: messageUserDS
});
